// Note that the collection is extended from an array.
// However be careful when iterating through the properties as we may have added additional properties which will also be iterated over.

import OnlineAppCollection from "./online_app_collection";

export default class RegionCollection extends OnlineAppCollection {

    constructor(onlineApp=null,...items) {
        super(onlineApp, ...items);
    }

    withCode(code) {
        if (this.isEmpty()) { return null }
        return this.filter( region => region.matchesCode(code) )[0] || null;
    }

    forFriendlyId(param) {
        if (this.isEmpty()) { return null }
        return this.filter( region => region.matchesFriendlyId(param) )[0] || null;
    }

    // Resolve the target region from the online app's URL params.
    // An explicit `code` (region_code) wins when it resolves; otherwise fall back to a
    // `friendlyId` (region_id — slug or integer id). Returns null when neither resolves.
    findForParams({ code, friendlyId } = {}) {
        if (code) {
            const region = this.withCode(code);
            if (region) { return region }
        }
        if (friendlyId) { return this.forFriendlyId(friendlyId) }
        return null;
    }

}
